import React from 'react';
import { connect } from 'react-redux';
import { DBCheckBoxObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationPostureScapularPosition extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Posture - Scapular Position' />
                    <label className={styles.label}>Scapular Position</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSCAPDOWNROT'
                        className={styles.checkbox}
                        label='Downward Rotated'
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSCAPINTROT'
                        className={styles.checkbox}
                        label='Internal Rotation'
                    />

                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSCAPUPROT'
                        className={styles.checkbox}
                        label='Upward Rotated'
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSCAPEXTROT'
                        className={styles.checkbox}
                        label='External Rotation'
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSCAPADD'
                        className={styles.checkbox}
                        label='Adducted'
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSCAPDEP'
                        className={styles.checkbox}
                        label='Depressed'
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSCAPABD'
                        className={styles.checkbox}
                        label='Abducted'
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSCAPWNL'
                        className={styles.checkbox}
                        label='WNL'
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSSCAPTILT'
                        className={styles.checkbox}
                        label='Tilt'
                    />
                </div>
            </div >
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSCAPDOWNROT ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSCAPUPROT ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSCAPADD ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSCAPABD ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSCAPTILT ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSCAPINTROT ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSCAPEXTROT ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSCAPDEP ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSSCAPWNL
            ? true : false
    };
}

const connectedObservationPostureScapularPosition = connect(mapStateToProps)(ObservationPostureScapularPosition);
export { connectedObservationPostureScapularPosition as ObservationPostureScapularPosition };


